import { Artwork } from "@touchscreen/brand-kit";
import "./Tile.css";

export function Tile(props: {
  title: string;
  subtitle?: string;
  artworkUrl?: string | null;
  /** Omit when the tile is browse-only (e.g. requests disabled). */
  onClick?: () => void;
}): React.JSX.Element {
  return (
    <button className="tile" type="button" onClick={props.onClick} disabled={!props.onClick}>
      <Artwork className="tile__artwork" src={props.artworkUrl} />
      <span className="tile__title">{props.title}</span>
      {props.subtitle ? <span className="tile__subtitle">{props.subtitle}</span> : null}
    </button>
  );
}
